(() => {
  const cleanPath = (u) => {
    try { return new URL(u || '', location.origin).pathname; }
    catch { return u || ''; }
  };

  const cleanImg = (u) => {
    const s = u || '';
    if (s.startsWith('//')) return `https:${s}`;
    return s;
  };

  // Toast
  const toast = (() => {
    let el, t;
    return (msg) => {
      if (!el) {
        el = document.createElement('div');
        el.className = 'wb-wl-toast';
        document.body.appendChild(el);
      }
      el.textContent = msg;
      el.classList.add('show');
      clearTimeout(t);
      t = setTimeout(() => el.classList.remove('show'), 1100);
    };
  })();

  const refreshAll = () => {
    const items = window.WBWishlist.read();
    const set = new Set(items.map(i => String(i.variantId)));

    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const on = set.has(String(btn.dataset.variantId));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = String(items.length);
    });
  };

  // Toggle wishlist
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();

    const variantId = String(btn.dataset.variantId || '');
    const handle = btn.dataset.handle || '';
    if (!variantId || !handle) return;

    const wasActive = window.WBWishlist.has(variantId);

    window.WBWishlist.toggle({
      variantId,
      handle,
      url: cleanPath(btn.dataset.url),
      title: btn.dataset.title || '',
      image: cleanImg(btn.dataset.image || ''),
      price: btn.dataset.price || '',      // ✅ NEW
      addedAt: Date.now()
    });

    toast(wasActive ? 'Removed from wishlist' : 'Added to wishlist');
  });

  // PDP variant sync (generic)
  document.addEventListener('change', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    form.querySelectorAll('[data-wishlist-toggle][data-wishlist-scope="pdp"]').forEach((btn) => {
      btn.dataset.variantId = idInput.value;
    });

    refreshAll();
  });

  // PDP variant sync (if theme dispatches this)
  document.addEventListener('variant:change', (evt) => {
    const v = evt?.detail?.variant;
    if (!v?.id) return;

    document
      .querySelectorAll('[data-wishlist-toggle][data-wishlist-scope="pdp"]')
      .forEach((btn) => (btn.dataset.variantId = v.id));

    refreshAll();
  });

  // Seamless after re-renders
  let t;
  const debouncedRefresh = () => {
    clearTimeout(t);
    t = setTimeout(refreshAll, 80);
  };

  new MutationObserver(debouncedRefresh).observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener('wishlist:changed', refreshAll);
  document.addEventListener('DOMContentLoaded', refreshAll);
})();
